<app-modal-template
	id="document-modal"
	[iconId]="182"
	[title]="'View Document'"
	[cancelText]="'Close'"
	(cancelClicked)="Close()"
	[showSave]="false"
>
	<div style="width: 100%; height: 100%; text-align: center">
		<!--Loading Indicator -->
		<app-spinner *ngIf="loading"></app-spinner>

		<!-- PDF Viewer -->
		<ngx-extended-pdf-viewer [src]="pdf" [height]="'calc(100vh - 200px)'" *ngIf="!loading && pdf">
		</ngx-extended-pdf-viewer>
	</div>
</app-modal-template>
